<template>
  <div>
    <component :is="activeHint" v-if="activeHint" />
  </div>
</template>

<script>
import store from './../../../mixins/store.mixin';
import currentJob from './../../../mixins/current_job.mixin'
import HintManager from '../../../manager/HintManager.js';
import HintsOcr from "../Hints/HintsOcr.vue";
import HintsCreatorStudio from "../Hints/HintsCreatorStudio.vue";

export default {
  name: "FileListHints",
  props: {},
  components: { HintsOcr, HintsCreatorStudio },
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {};
  },
  mounted: function () {},
  created: function () {},
  methods: {},
  computed: {
    showOCRHint() {
      return HintManager.showOcrHint(this.currentJob.apiJob);
    },
    showCreatorStudioHint() {
      return false;
    },
    activeHint() {
      if (this.showOCRHint) {
        return HintsOcr;
      }
      if (this.showCreatorStudioHint) {
        return HintsCreatorStudio;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
